import { useState } from 'react'

import { Divider, Menu, TextInput, Tooltip, Loader } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import {
  MenuChevron,
  TASK_MENU_CLASSNAMES,
} from 'src/components/Shared/TaskMenus/taskMenuStyles'
import { GET_APPLICANTS } from 'src/graphql/applicants.graphql'
import { buildFullName } from 'src/lib/formatters'

import { toast } from '../../Toast/Toast'

const ApplicantMenu = ({ applicant, setApplicant, onNavigate = null }) => {
  const [search, setSearch] = useState('')

  const { data: applicantsData, loading } = useQuery(GET_APPLICANTS, {
    notifyOnNetworkStatusChange: true,
    variables: {
      pageInfo: {
        offset: 0,
        limit: 20,
      },
      filters: {
        searchText: search,
      },
    },
    onError: () => {
      toast('Unable to get applicants, please try again.', 'error')
    },
  })

  const applicants = applicantsData?.applicants?.items || []

  return (
    <Menu
      offset={6}
      width={185}
      position="bottom-start"
      classNames={TASK_MENU_CLASSNAMES}
    >
      <Menu.Target>
        <div className="flex cursor-pointer items-center gap-1 text-xs">
          {applicant ? (
            // Blue name jumps to the applicant details page; the chevron opens
            // the picker to change it.
            <Tooltip
              label="Go to applicant details"
              position="top"
              className="text-xs"
              disabled={!onNavigate}
            >
              <button
                type="button"
                className="font-medium text-doubleNickel-brand-500 hover:underline"
                onClick={(e) => {
                  if (onNavigate) {
                    e.stopPropagation()
                    onNavigate()
                  }
                }}
              >
                {buildFullName(applicant)}
              </button>
            </Tooltip>
          ) : (
            <span className="text-doubleNickel-gray-700 hover:text-doubleNickel-gray-900">
              No Applicant
            </span>
          )}
          <MenuChevron />
        </div>
      </Menu.Target>

      <Menu.Dropdown>
        <TextInput
          variant="unstyled"
          placeholder="Search applicant"
          size="xs"
          className="mx-2"
          value={search}
          onChange={(event) => setSearch(event.currentTarget.value)}
          rightSection={loading ? <Loader size={14} color="gray" /> : null}
        />
        <Divider />
        <div className="flex max-h-64 flex-col gap-1 overflow-y-auto">
          <Menu.Item onClick={() => setApplicant(null)}>No applicant</Menu.Item>
          {applicants.map((applicant) => (
            <Menu.Item
              key={applicant.applicantId}
              onClick={() => setApplicant(applicant)}
            >
              {buildFullName(applicant)}
            </Menu.Item>
          ))}
        </div>
      </Menu.Dropdown>
    </Menu>
  )
}

export default ApplicantMenu
